import {
  Component,
  Input,
  OnInit,
  WritableSignal,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
  selector: 'mzic-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,
  ],
  providers: [provideNgxMask()],
  templateUrl: './mzic-input.component.html',
  styleUrls: ['./mzic-input.component.scss'],
})
export class MzicInputComponent implements OnInit {
  @Input({ required: true }) type!: string;
  @Input() placeholder!: string;
  @Input() label!: string;
  @Input({ required: true }) controlName!: string;
  @Input() mask!: string;
  @Input() textError!: string;
  @Input() icon!: string;
  @Input({ required: true }) ariaLabelText!: string;
  @Input({ required: true }) ariaLabelInput!: string;

  protected form!: FormGroup;
  private _showPassword: WritableSignal<string> = signal('password');
  constructor(private readonly _controlContainer: ControlContainer) {}

  ngOnInit(): void {
    this.form = this._controlContainer.control as FormGroup;
  }

  public showPassword(): void {
    this._showPassword() === 'password'
      ? this._showPassword.set('text')
      : this._showPassword.set('password');
    this.type = this._showPassword();
  }
}
